import React, { PropTypes } from 'react';
import { FlatButton } from 'material-ui';
import RaisedButton from '../../../tc-ui/raised-button-with-loader';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

const CancelOrConfirm = ({
  callingApi,
  confirmFn,
  cancelFn,
  disableConfirmBtn,
  cancelLabel,
  confirmLabel,
  forDelete,
}) => (
  <div style={{ display: 'flex', flexDirection: 'row-reverse', position: 'relative' }}>
    <FlatButton
      style={{ minWidth: '68px', marginLeft: '8px' }}
      label={cancelLabel || 'cancel'}
      onTouchTap={cancelFn}
    />
    <RaisedButton
      style={{ minWidth: '68px' }}
      label={confirmLabel || 'confirm'}
      disabled={disableConfirmBtn}
      icon={forDelete && (<DeleteIcon/>)}
      secondary={!forDelete}
      primary={forDelete}
      onTouchTap={confirmFn}
      loader={callingApi}
    />
  </div>
);

CancelOrConfirm.propTypes = {
  callingApi: PropTypes.bool,
  confirmFn: PropTypes.func,
  cancelFn: PropTypes.func,
};

export default CancelOrConfirm;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/cancel-confirm-buttons.jsx